import React, { memo, useEffect } from 'react';
import styles from './styles/product-inventory-header.scss';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import { useSelector } from "react-redux";
import { pageLoad, pageLoadForIos } from '../../../common/Utills';
import { identifyAuditFlow } from '../../../utills';
import config from '../../../../config/config'

function ProductInventoryHeader(props) {
  const { onSearch, onBulkUpdate } = props;
  const isJdSourceAndroid = useSelector((state) => state.session.isJdSourceAndroid);
  const isJdBusinessIOS = useSelector(state => state.session.isJdBusinessIOS);
  const isJdSourceIOS = useSelector((state)=> state.session.isJdSourceIOS)
  const redirectToJdExt = useSelector((state)=> state.session.redirectToJdExt)
  const isSourceJustdial = isJdSourceAndroid || isJdSourceIOS;
  const toSellerDash = identifyAuditFlow({query : true}).sd;
  const inventorySession = useSelector((state) => state.session);
  
  const backHandleClick =()=>{
    let sdBackhandle = ['','2','52'].indexOf(inventorySession.userSource) != -1;
    if(toSellerDash == '1'&& (sdBackhandle || !inventorySession.userSource)){
      window.location.replace(config.dcBizDomainUrl+'/seller-dashboard?source='+inventorySession.userSource+'&docid='+inventorySession.docId)
    }
    else if(isJdSourceAndroid || isJdBusinessIOS){
        window.location.replace('https://jdext.php')
    }else{ 
        window.history.back();
    }
  };

  useEffect(()=>{
    if(window){
        window.appHandler = (jsonStr) => {
            try {
            console.log('callback',jsonStr);
            const transformedJson = JSON.parse(jsonStr);
            const {eventType, redirectionurl} = transformedJson;
            if(redirectionurl){
                window.location.replace(redirectionurl);
            }else if(eventType == "deviceback"){
                if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                    const exitJson ={"action":"exit"};
                    JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                }
            }
            } catch (e) {
            console.log(e)
            }
        };
        if(isJdSourceAndroid){
          pageLoad();
        }else if (isJdBusinessIOS) {
          pageLoadForIos();
        }
    }
  },[]);
  return (
    <div className={styles['inventory-header']}>
      <div className={styles['header']}>
      { !(isJdSourceAndroid || isJdBusinessIOS)?
      <div className={styles['back-button']}>
        <AnimateOnHover
            className={styles['full-height']}
            onClick={backHandleClick}
        >
          <div
            className={`${styles['icon-holder']}`}
          >
            <i className='icon-hdrBackNew' style={{ fontSize: '1rem' }} />
          </div>
        </AnimateOnHover>
      </div>:null}
        <div className={`${styles['header-title']} ${isJdSourceAndroid || isJdBusinessIOS ? styles['back-icon-remove']:''}`}>Inventory</div>
      </div>
      <div className={styles['icon-container']}>
      <AnimateOnHover
				className={styles['full-height']}
        onClick={onBulkUpdate}
				>
        <div
          className={`${styles['icon-holder']} `}
        >
          <i className='icon-glimport' style={{ fontSize: '1rem' }} />
        </div>
      </AnimateOnHover>
        <AnimateOnHover
            className={styles['full-height']}
            onClick={onSearch}
        >
          <div
            className={`${styles['icon-holder']}`}
          >
            <i className='icon-HDRsearch' style={{ fontSize: '1rem' }} />
          </div>
        </AnimateOnHover>
      </div>
    </div>
  )
}

export default memo(ProductInventoryHeader);